import { createContext } from "react";

// The open ModalDialog's <dialog>, in the browser's top layer: what floats over its content (a Select's menu) is
// rendered in it, else it would be drawn under the modal dialog, whatever its z-index.
export const ModalDialogContext = createContext<HTMLDialogElement | null>(null);
